import { ApiPath } from "enums";
import { Get } from "utils";

export const getTransactions = async (query) => {
  const res = await Get(`${ApiPath.Transaction}/${query?.stationCode}`, query);
  return res.data;
};

export const getTransactionsItems = async (query) => {
  const res = await Get(`${ApiPath.Transaction}/${query?.stationCode}/item`, query);
  return res.data;
};
